export default __webpack_public_path__ + "static/media/mons12.11623311.jpg";